import React from 'react';
import { FeedbackOption } from '../feedback-config';

interface ChipSelectProps {
  options: readonly FeedbackOption[];
  value: string[];
  onChange: (value: string[]) => void;
}

const toggle = (value: string[], key: string): string[] =>
  value.includes(key) ? value.filter((v) => v !== key) : [...value, key];

/**
 * Desktop multi-select: toggleable category chips.
 * Selection is optional and multiple chips can be active at once.
 */
const ChipSelect: React.FC<ChipSelectProps> = ({
  options,
  value,
  onChange,
}) => (
  <div className='flex flex-wrap gap-1'>
    {options.map((option) => {
      const selected = value.includes(option.value);
      return (
        <button
          key={option.value}
          type='button'
          aria-pressed={selected}
          data-testid={`chip-${option.value}`}
          onClick={() => onChange(toggle(value, option.value))}
          className={`rounded-full border px-4! py-2! text-sm! font-medium transition-colors ${
            selected
              ? 'border-(--ayvens-theme-brand-primary-400) bg-(--ayvens-theme-brand-primary-400) text-white'
              : 'hover:bg-(--ayvens-theme-brand-primary-400) border-(--ayvens-theme-neutral-neutral-200) bg-(--ayvens-theme-neutral-neutral-200) text-(--ayvens-theme-brand-secondary-400) '
          }`}
        >
          {option.label}
        </button>
      );
    })}
  </div>
);

export default ChipSelect;
